<app-topbar></app-topbar>
<main class="layout-container">
    <div class="layout-content-wrapper">
        <div class="layout-content">
           
                <p class="text-900 text-3xl font-medium mb-3 mt-3">Usuários</p>
      
  <p-card class="mx-2 md:mx-8 mb-5">
    <form class="font-semibold">
      <label for="cpf" class="mx-2">CPF <span class="text-red-500">*</span></label>
      <div class="formgroup-inline">
        <div class="field col-12 md:col-4">
          <p-inputMask placeholder="999.999.999-99" mask="999.999.999-99" formControlName="cpf" required></p-inputMask>
        </div>
        <p-button pRipple label="Pesquisar" class="ml-1"></p-button>
      </div>
      <div class="mx-2 field">
        <label for="nome">Nome <span class="text-red-500">*</span></label>
        <input placeholder="Nome" pInputText required formControlName="nome" />
      </div>
      <div class="mx-2 field flex flex-wrap gap-3 p-fluid">
        <div class="flex-auto">
          <label for="email">Email <span class="text-red-500">*</span></label>
          <input placeholder="Email" class="mt-1" pInputText required formControlName="email" />
        </div>
        <div class="flex-auto">
          <label for="grupo">Grupo de Permissões <span class="text-red-500">*</span></label>
          <p-dropdown optionLabel="grupo" placeholder="Selecione um Grupo"></p-dropdown>
        </div>
      </div>
      <div class="mx-2 mt-4 field mb-4">
        <label for="status" class="font-normal">Status do Usuário <span class="text-red-500">*</span></label>
        <div class="flex flex-wrap gap-3">
          <div class="flex align-items-center">
            <p-radioButton name="status" value="ativo" inputId="ativo" />
            <label for="ativo" class="ml-2">Ativo</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="status" value="inativo" inputId="inativo" />
            <label for="inativo" class="ml-2">Inativo</label>
          </div>
        </div>
      </div>
      <div class="mx-2 mt-3 flex gap-2">
        <p-button pRipple label="Salvar"></p-button>
        <p-button pRipple severity="secondary" label="Limpar" ></p-button>
      </div>
      <p-table class="mt-5 p-datatable-gridlines p-datatable-striped" responsiveLayout="stack">
        <ng-template pTemplate="caption">Usuários Cadastrados</ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="cpf">CPF <p-sortIcon field="cpf"></p-sortIcon></th>
            <th pSortableColumn="nome" class="text-center">Nome <p-sortIcon field="nome"></p-sortIcon></th>
            <th pSortableColumn="email" class="text-center">Email <p-sortIcon field="email"></p-sortIcon></th>
            <th pSortableColumn="permissao" class="text-center">Permissão <p-sortIcon field="permissao"></p-sortIcon></th>
            <th class="text-center">Ação</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <tr>
            <td>Id</td>
            <td class="text-center">Categoria</td>
            <td class="text-center">Status</td>
            <td class="text-center">
              <p-button icon="pi pi-pencil" pTooltip="Editar" tooltipPosition="top" class="p-button-sm p-button-primary mr-2"></p-button>
              <p-button icon="pi pi-trash" pTooltip="Deletar" tooltipPosition="top" class="p-button-sm p-button-danger"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </form>
  </p-card>
  </div>
  </div>
</main>
